angular.module('autoremind.reports.communication')
    .directive('reportsRecalls', ['$rootScope', '$location', 'userProfile',
    function ($rootScope, $location, userProfile) {
        return {
            templateUrl: 'app/reports/communication/recalls/recalls.html',
            scope: true,
            link: function (scope, elem, attr) {
                // Initialize
                userProfile.initalizeViewModel();
                userProfile.getProfileIfNotLoaded(function () {
                    console.debug('reportsRecalls: got user profile');
                });
                if (userProfile.viewModel.views.reportsRecalls === undefined) {
                    userProfile.viewModel.views.reportsRecalls = {};
                }
                scope.viewModel = userProfile.viewModel.views.reportsRecalls;
                scope.viewModel.loadingIndicator = {
                    refCount: 0,
                    state: false
                };
                scope.viewModel.successful = [];
                scope.viewModel.inProgress = [];
                scope.viewModel.unsuccessful = [];
                scope.viewModel.viewMessages = false;
                scope.viewModel.selectedFilter = null;
                scope.viewModel.totalMessages = 0;
                $rootScope.$on('event:auth-loginConfirmed', function () {
                    $location.search('jobid', null);
                });
            }
        };
    }]);
//# sourceMappingURL=recalls.directive.js.map